import Text from '@components/atoms/Text/Text'
import Translate from '@components/atoms/Translate/Translate'
import config from '@config/'
import { toKb } from '@utils/file'
import c from 'classnames'
import styles from './DropZoneUi.module.scss'

const DropZoneUi = () => {
  const { allowedFileTypes, maxFileSizeBytes } = config.files

  return (
    <div className={c(styles.base, 'border-brandLight c-brand25')}>
      <div className={styles.icon}>
        <i className="icon icon-upload" />
      </div>
      <div className={styles.title}>
        <Text type="text-l">
          <Translate str="steps.upload.dropzone.title" />
        </Text>
      </div>
      <div className={styles.info}>
        <Text type="text-xs">
          <Translate
            str="steps.upload.dropzone.info"
            vars={{
              n: toKb(maxFileSizeBytes),
              s: allowedFileTypes.join(','),
            }}
          />
        </Text>
      </div>
    </div>
  )
}
export default DropZoneUi
